import { createContext, useContext, ReactNode } from 'react';
import { useSecuritySession } from '@/hooks/useSecuritySession';

interface SecurityContextType {
  lastActivity: number;
  showTimeoutWarning: boolean;
  extendSession: () => void;
}

const SecurityContext = createContext<SecurityContextType | undefined>(undefined);

export const useSecurityContext = () => {
  const context = useContext(SecurityContext);
  if (!context) {
    throw new Error('useSecurityContext must be used within a SecurityProvider');
  }
  return context;
};

interface SecurityProviderProps {
  children: ReactNode;
}

export const SecurityProvider = ({ children }: SecurityProviderProps) => {
  const securitySession = useSecuritySession();

  return (
    <SecurityContext.Provider value={securitySession}>
      {children}
    </SecurityContext.Provider>
  );
};
